/** Pages of the docs' navigation that carry a mark: new within the last weeks, or updated since. */
export const DOCS_MENU_UPDATES: Record<string, string> = {
  envelope: "Updated",
  fader: "Updated",
  knob: "Updated",
  meter: "Updated",
  mixer: "New",
  pad: "New",
  plot: "New",
  compressor: "New",
  equalizer: "New",
  delay: "New",
  reverb: "New",
  filter: "New",
  distortion: "New",
  chorus: "New",
  "pocket-synth": "New",
  "wave-shaper": "New",
  utility: "New",
  limiter: "New",
  gate: "New",
  saturator: "New",
  phaser: "New",
  "auto-pan": "New",
  "channel-eq": "New",
  overdrive: "New",
  redux: "New",
  deesser: "New",
  multiband: "New",
  transient: "New",
  "mid-side": "New",
  "piano-roll": "New",
  scrubber: "New",
  sequencer: "Updated",
  "spectrum-analyzer": "New",
  timeline: "New",
  tuner: "New",
  waveform: "Updated",
};

/** The same for the catalog's categories. */
export const PATTERNS_MENU_UPDATES: Record<string, string> = {
  envelope: "Updated",
  fader: "Updated",
  knob: "Updated",
  meter: "Updated",
  device: "New",
  mixer: "New",
  pad: "New",
  piano: "New",
  plot: "New",
  scrubber: "New",
  sequencer: "Updated",
  spectrum: "New",
  timeline: "New",
  tuner: "New",
  waveform: "Updated",
};
